/**
 * @generated SignedSource<<e96334f1e981179c5a733323a5bdaeff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodBoletoSelected_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompleted_query">;
  readonly " $fragmentType": "PaymentMethodBoletoSelected_query";
};
export type PaymentMethodBoletoSelected_query$key = {
  readonly " $data"?: PaymentMethodBoletoSelected_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodBoletoSelected_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodBoletoSelected_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "37a0deff883afd180fdb392aff820c6f";

export default node;
